








































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { CruiseTrackDetailData } from '@/api/heritageCruise/cruiseTrack'
import icon_center from '@/assets/gis_icons/center.png'
import icon_check from '@/assets/gis_icons/daka.png'
import icon_marker from '@/assets/gis_icons/xuncha.png'
import icon_beiwen from '@/assets/gis_icons/beiwen.png'
import icon_trackStart from '@/assets/gis_icons/trackstart.png'
import icon_trackEnd from '@/assets/gis_icons/trackend.png'
import icon_Video_Online from '@/assets/gis_icons/video_online.png'
import icon_Video_Offline from '@/assets/gis_icons/video_offline.png'
import {
  monitorAreaColor, protectAreaColor, keyProtectAreaColor,
  cruiseTrackColor
} from '@/configs/webConfig'
import { UnitPositionMapData, MapPolyData, MapMarkData, MapCoordData, CheckPointData, MapIconType } from '@/api/common/mapData'
import { dateFormat, getBdCoord, newGuid, openVideo } from '@/configs/functions'

import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
import { enPositionType } from '@/configs/enums'
const UserModule = namespace('user')

@Component
export default class UnitMap extends Vue {
  public mapId: string = newGuid()
  @Prop({ default: '' })
  public mapHeight!: string
  @Prop({ default: true })
  public showHeader!: boolean

  @UserModule.Getter('userInfo')
  public curUser!: UserData
  public $refs!: {
    // refBdMap: any
  }
  public showMap: boolean = false
  public fullScreen: boolean = false
  public zoom: number = 11
  public center: any = { lng: 0, lat: 0 }
  public areaName: string = ''
  /** 多边形及折线坐标集合 */
  public polygons: MapPolyData[] = []
  /** 覆盖物坐标集合 */
  public markers: MapMarkData[] = []
  /** 视频监控点集合 */
  public videos: MapMarkData[] = []
  public getCoord(lng: number, lat: number) {
    var f = getBdCoord({ lng: lng, lat: lat })
    return { lng: f.lng, lat: f.lat }
  }
  /** 地图图标导航 根据后端返回的数据动态生成 */
  public navIcons: {
    Type: MapIconType
    Icon: string//图标，还是色块, 存图标地址，如果是空就是色块
    BgColor: string//色块颜色
    Title: string
    Coords: MapCoordData[]
  }[] = [
      { Type: 'UnitDefault', Icon: icon_center, BgColor: '', Title: '中心点', Coords: [] },
      { Type: 'Epigraphy', Icon: icon_beiwen, BgColor: '', Title: '碑文', Coords: [] },
      { Type: 'CruisePoint', Icon: icon_marker, BgColor: '', Title: '巡查点', Coords: [] },
      { Type: 'CheckPoint', Icon: icon_check, BgColor: '', Title: '打卡点', Coords: [] },
      { Type: 'MonitorArea', Icon: '', BgColor: monitorAreaColor, Title: '建控地带', Coords: [] },
      { Type: 'ProtectArea', Icon: '', BgColor: protectAreaColor, Title: '保护范围', Coords: [] },
      { Type: 'KeyProtectArea', Icon: '', BgColor: keyProtectAreaColor, Title: '重点保护范围', Coords: [] },
      { Type: 'CruiseTrack', Icon: '', BgColor: cruiseTrackColor, Title: '巡查轨迹', Coords: [] },
      { Type: 'VideoPoint', Icon: icon_Video_Online, BgColor: '', Title: '监控点', Coords: [] }
    ]
  public setCenter(index: number) {
    var e = this.navIcons[index]
    if (e && e.Coords.length > 0) {
      let coord = e.Coords[0]
      let lng = coord.lng
      let lat = coord.lat
      let zoom = 11
      if (lng != 0 && lat != 0 && this.isPoint(lng, lat)) {
        if (this.center.lng == lng && this.center.lat == lat) {
          this.center = { lng: 0, lat: 0 }
          setTimeout(() => {
            this.center = { lng: lng, lat: lat }
            this.setMapViewPort(e.Coords)
          }, 250)
        }
        else {
          this.center = { lng: lng, lat: lat }
          setTimeout(() => {
            this.setMapViewPort(e.Coords)
          }, 500)
        }
        this.zoom = zoom
      }
      else {
        this.$message({
          message: '无坐标数据',
          type: 'warning'
        })
      }
    }
    else {
      this.$message({
        message: '无坐标数据',
        type: 'warning'
      })
    }
  }
  //生成坐标数组
  public coordArray(area: any[]) {
    return area.map((p: any) => {
      return this.getCoord(p.Longitude, p.Latitude)
    })
  }
  public isPoint(lng: number, lat: number) {
    return lng > 0 && lng < 180 && lat > 0 && lat < 90
  }
  public formatTime(date: any | Date) {
    return dateFormat(date, 'hh:mm')
  }
  public map: any = null
  public BMap: any = null
  public mapLoad(info: any) {
    if (this.map) {
      this.map.reload()
    }
    // this.setMapOptions()
  }
  public mapInit(info: { BMap: any, map: any }) {
    this.BMap = info.BMap
    this.map = info.map

    const u = this.curUser
    if (u && u.SysAuth) {
      const defArea = u.SysAuth.ProvinceName
      this.areaName = defArea
      if (u.CountyId > 0 || u.SysAuth.UsedBy == 'County') {
        this.areaName = u.CountyId > 0 ? (u.CityName + u.CountyName) : defArea
      }
      else if (u.CityId > 0 || u.SysAuth.UsedBy == 'City') {
        this.areaName = u.CityId > 0 ? u.CityName : defArea
      }
    }
    // console.log(dateFormat(new Date(), 'hh:mm:ss.ms') + ':地图加载完成，设置默认中心点:' + this.areaName)
    if (this.areaName != '' && this.center.lng == 0) {
      //设置当前城市为中心点
      this.map.centerAndZoom(this.areaName, this.zoom)
    }
    else {
      console.log('因数据坐标已经加载完成，为了避免显示错误，这里不需要设置默认坐标，跳过', this.center)
    }

    // this.map.setMapStyle({ style: 'googlelite' })
    // var c = this.center
    // if (c != {}) {
    //   var point = new this.BMap.Point(c.lng, c.lat)
    //   this.map.centerAndZoom(point, this.zoom)
    // }
  }
  public mapUnLoad(info: any) {
    // console.log('mapUnLoad', info)
  }
  public mapReLoad(info: any) {
    // console.log('mapReLoad', info)
  }
  //拖动或放大缩小的时候，清除中心点
  public dragOrZoom(info: any) {
    // console.log('dragOrZoom', info)
    // this.center = { lng: 0, lat: 0 }
  }
  public mapResize(info: any) {
    // console.log('resize', info)
    this.map.zoomIn()//放大一级
    this.map.zoomOut()//缩小一级
  }
  public videoClick(i: number) {
    var e = this.videos[i]
    var data = e.Data
    if (data.Online != 1) {
      this.$message.warning('视频已离线')
      return false
    }
    if (data && data.Online == 1) {
      //弹窗播放视频
      // console.log(data, data.PointNumber)
      // this.$message.warning('弹窗播放视频')
      var info = {
        title: data.PointName,
        code: data.PointNumber,
        playBack: false,
        storageType: data.StorageType
      }
      if (window.baseConfig.UseH5Player) {
        window.eventBus.$emit('openH5Player', info)
      }
      else {
        openVideo(info)
        // window.eventBus.$emit('openVideoPlay', info)
      }
    }
  }
  public mounted() {
  }

  /**监控点坐标预览 */
  public loadCameraPoint(points: MapCoordData[], title: string) {

  }

  public loadData(data: {
    checkPoint: CheckPointData
    positions: UnitPositionMapData[]
    tracks: CruiseTrackDetailData[]
    obj: any
  }) {
    this.closeMap()
    this.setMapOptions(data)
    this.showMap = true
  }
  //坐标格式化
  public setMapOptions(data: {
    /** 打卡点 */
    checkPoint: CheckPointData
    /** 地理坐标，保护范围，建控地带等 */
    positions: UnitPositionMapData[]
    /** 巡查轨迹 */
    tracks: CruiseTrackDetailData[]
    obj: any
  }) {
    var checkPoint = data.checkPoint
    var positions = data.positions || []
    var tracks = data.tracks
    var obj = data.obj

    let center = new MapCoordData()
    let coord = new MapCoordData()
    let title = ''
    let content = ''

    //地图上的所有坐标点，用来在最后面调用setViewport使用
    let allPoints: any = []
    //#region 配置地图标识点和文保单位区域图
    //按单位id和坐标类型分组
    let polygonGroup: string[] = []
    let navType: MapIconType = ''
    //需要配置为覆盖物的坐标类型
    const markerCategories: number[] = [
      enPositionType.UnitDefault,
      enPositionType.Epigraphy,
      enPositionType.CruisePoint
    ]
    positions.forEach((e: UnitPositionMapData) => {
      coord = this.getCoord(e.Longitude, e.Latitude)
      //判断坐标是否有效
      if (this.isPoint(coord.lng, coord.lat)) {
        allPoints.push(coord)
        content = ''
        title = e.Title
        let iconUrl = icon_center
        let isMarker = markerCategories.indexOf(e.Category) > -1
        //中心点,碑文,巡查点，需要添加到marks中。其他的需要添加到 polygons 中
        if (e.Category == enPositionType.UnitDefault) {
          //中心点
          if (!e.IsPart) {
            center = coord
            navType = 'UnitDefault'
          }
          iconUrl = icon_center
          title = obj && obj.unitName ? obj.unitName : title
          content = `<div class="pop-arrow"><div class="content">${title}</div><div class="arrow"></div></div>`
        }
        if (e.Category == enPositionType.Epigraphy) {
          if (!e.IsPart) {
            navType = 'Epigraphy'
          }
          //碑文
          iconUrl = icon_beiwen
        }
        if (e.Category == enPositionType.CruisePoint) {
          if (!e.IsPart) {
            navType = 'CruisePoint'
          }
          //巡查点
          iconUrl = icon_marker
        }

        if (isMarker) {
          this.markers.push({
            IconUrl: iconUrl,
            Coord: coord,
            Title: title,
            Content: content
          })

          if (navType != '') {
            this.setNavCoord(navType, [coord])
          }
        }
        else {
          const polygonKey = e.UnitId + '_' + e.Category
          if (polygonGroup.indexOf(polygonKey) == -1) {
            polygonGroup.push(polygonKey)
            let color = e.Category == enPositionType.MonitorArea ? monitorAreaColor : (
              e.Category == enPositionType.ProtectArea ? protectAreaColor : keyProtectAreaColor
            )
            const newPosi = positions.filter(v => v.UnitId == e.UnitId && v.Category == e.Category)
            let coords = this.coordArray(newPosi)
            //多边形
            this.polygons.push({
              Type: 'polygon',
              Coords: coords,
              StrokeColor: color
            })
            if (!e.IsPart) {
              if (e.Category == enPositionType.MonitorArea) {
                navType = 'MonitorArea'
              }
              if (e.Category == enPositionType.ProtectArea) {
                navType = 'ProtectArea'
              }
              if (e.Category == enPositionType.KeyProtectArea) {
                navType = 'KeyProtectArea'
              }
              // coord = coords[0]
              if (navType != '') {
                this.setNavCoord(navType, coords)
              }
            }
          }
        }
      }
    })
    //#endregion

    //#region 配置打卡点
    if (checkPoint && checkPoint.pointId > 0) {
      coord = this.getCoord(checkPoint.lng, checkPoint.lat)
      if (this.isPoint(coord.lng, coord.lat)) {
        allPoints.push(coord)
        center = coord
        title = checkPoint.pointName ? checkPoint.pointName : '打卡点'
        content = `<div class="pop-arrow risk2"><div class="content">${title}</div><div class="arrow"></div></div>`
        //添加打卡点坐标
        this.markers.push({
          IconUrl: icon_check,
          Title: title,
          Coord: coord,
          Content: content
        })
        this.setNavCoord('CheckPoint', [coord])
      }
    }
    //#endregion

    //#region 巡查轨迹
    if (tracks && tracks.length > 1) {
      this.zoom = 18
      let start = tracks[0]
      //如果有巡查轨迹的话，起点和终点加两个图标
      let coord = this.getCoord(start.Longitude, start.Latitude)
      if (this.isPoint(coord.lng, coord.lat)) {
        allPoints.push(coord)
        this.center = coord
        this.markers.push({
          IconUrl: icon_trackStart,
          Title: '',
          Coord: coord,
          Content: `<div class="pop-arrow track-start"><div class="content">开始(${this.formatTime(start.NewDate)})</div><div class="arrow"></div></div>`
        })
      }
      let end = tracks[tracks.length - 1]
      coord = this.getCoord(end.Longitude, end.Latitude)
      if (this.isPoint(coord.lng, coord.lat)) {
        this.markers.push({
          IconUrl: icon_trackEnd,
          Title: '',
          Coord: coord,
          Content: `<div class="pop-arrow track-end"><div class="content">结束(${this.formatTime(start.NewDate)})</div><div class="arrow"></div></div>`
        })
      }
      let coords = this.coordArray(tracks)
      //添加线段
      this.polygons.push({
        Type: 'polyline',
        Coords: coords,
        StrokeColor: cruiseTrackColor
      })
      this.setNavCoord('CruiseTrack', coords)
    }
    //#endregion

    //#region 监控点坐标
    this.videos = []
    if (obj.videos && obj.videos.length > 0) {
      let coords: any = []
      obj.videos.forEach((e: any) => {
        coord = this.getCoord(e.Longitude, e.Latitude)
        coords.push(coord)
        //判断坐标是否有效
        if (this.isPoint(coord.lng, coord.lat)) {
          allPoints.push(coord)
          let iconUrl = e.Online == 1 ? icon_Video_Online : icon_Video_Offline
          this.videos.push({
            IconUrl: iconUrl,
            Coord: coord,
            Title: e.Online == 1 ? `点击播放:[${e.PointName}]` : '视频已离线',
            Content: `<div class="map-videos">
              <div class="pop-arrow ${e.Online == 1 ? 'online' : 'offline'}">
                <div class="content">${e.PointName}</div>
                <div class="arrow"></div>
              </div>
              <img src="${iconUrl}" />
            </div>`,
            Data: e
          })
        }
      })
      this.setNavCoord('VideoPoint', coords)
    }
    //#endregion

    if (allPoints.length > 0) {
      setTimeout(() => {
        // console.log(dateFormat(new Date(), 'hh:mm:ss.ms') + ':延迟时间到，设置中心点')
        this.center = center
        //this.zoom = 11
        this.setMapViewPort(allPoints)
        console.log('设置中心点和级别')
        // console.log(this.map.getViewport())
        //500毫秒后设置动态中心点
        // this.map.centerAndZoom(center, this.zoom)
      }, 1000)
    }
  }
  public setMapViewPort(points: any[]) {
    this.map.setViewport(points)
    console.log('setViewport')
  }
  public setNavCoord(type: MapIconType, coords: MapCoordData[]) {
    var item = this.navIcons.find(v => v.Type == type)
    if (item) {
      item.Coords = coords
    }
  }

  public clearMap() {
    this.zoom = 16
    this.center = { lng: 0, lat: 0 }
    this.markers = []
    this.polygons = []
  }
  public closeMap() {
    this.clearMap()
    this.showMap = false
  }
  // public beforeDestroy() {
  //   if (this.map) {
  //     this.map.clearOverlays()
  //   }
  //   window.eventBus.$off('loadUnitMap')
  // }
  // public deactivated() {
  //   console.log('deactivated')
  //   this.$destroy()
  // }
}
